const CR_PLUS_CTA_COOKIE = 'crplusctamembership';
const CR_PREM_PLUS_COOKIE = 'premplusctav';
const CR_FT_COOKIE = 'ftctav';

const COOKIE_EXPIRATION_ONE_YEAR = 365;

export {
  CR_PLUS_CTA_COOKIE,
  CR_PREM_PLUS_COOKIE,
  CR_FT_COOKIE,
  COOKIE_EXPIRATION_ONE_YEAR,
};
